<template>
  <div class="group-members-container">
    <div class="ui-block">
      <div class="ui-block-title d-flex justify-content-end no-padding">
        <a
          v-if="isMember"
          href="#"
          class="accept-request btn-size float-right"
          data-toggle="modal"
          data-target="#invite-members"
          data-cy="inviteMembers"
        >
          <span class="add-person-icon-text">
            <svg class="add-person-icon">
              <use xlink:href="/svg-icons/sprites/icons.svg#add-person-icon" />
            </svg>
            <span>Invite user</span>
          </span>
        </a>
      </div>
      <ul class="notification-list friend-requests">
        <MembersList @button="openModalRemove"/>
      </ul>
    </div>
    <Modal
      id="removeGroupMember"
      buttonName="Remove"
      title="Remove group member"
      ref="removeGroupMember"
      @button="removeGroupMember"
      :disabled="isLoading"
    >
      <p>Are you sure you want to remove this member?</p>
      <LoadingSpinner position="absolute" v-if="isLoading" />
    </Modal>
    <Modal
      id="removedMember"
      buttonName="Ok"
      title="Member removed with success"
      ref="removedMember"
      @button="reloadPage"
      @hide="reloadPage"
    >
      <p>Member removed!</p>
    </Modal>
    <ModalInviteNewMember />
  </div>
</template>

<script>
import MembersList from "@/components/atoms/MembersList";
import ModalInviteNewMember from "@/components/molecules/ModalInviteNewMember";
import GroupHelperVue from "../../mixins/GroupHelper.vue";
import UserHelperVue from "../../mixins/UserHelper.vue";
import Modal from '../atoms/Modal.vue';
import LoadingSpinner from "@/material-components/atoms/LoadingSpinner.vue";
export default {
  name: "GroupsMembership",
  mixins: [GroupHelperVue, UserHelperVue],
  components: {
    MembersList,
    ModalInviteNewMember,
    Modal,
    LoadingSpinner
},
data() {
  return {
    memberIdToRemove: null,
    isLoading: false,
  }
},
methods: {
  openModalRemove(memberId) {
    this.memberIdToRemove = memberId;
      $("#removeGroupMember").modal("show");
    },
    async removeGroupMember() {
      this.isLoading = true;
      await this.removeMember({groupId: this.getCurrentGroup.id, userId: this.memberIdToRemove})
      this.isLoading = false;
      this.$refs.removeGroupMember.closeModal();
      $("#removedMember").modal("show");
    },
    reloadPage() {
      this.$refs.removedMember.closeModal();
      window.location.reload();
    }
},
  computed: {
    isMember() {
      return !!(this.myGroups.find((group) => {
          return group.groupId === this.getCurrentGroup.id
        }));
    },
  }
};
</script>

<style scoped>
.group-members-container {
  flex: 0 0 calc(100% - 260px);
  padding: 0 8px;
}
.ui-block {
  background-color: unset;
  border: unset;
}
.accept-request {
  padding: 3px;
}

.add-person-icon {
  width: 25px;
  height: 25px;
  margin: 0 5px ;
}
.add-person-icon-text {
  display: flex;
  align-items: center;
  color: white !important;
}

.add-person-icon-text span {
  font-size: 14px;
  margin-right: 4px;
  letter-spacing: 1px;
}
.btn-size {
  width: 200px;
  display: flex;
  justify-content: center;
}
@media screen and (max-width: 1024px) {
  .group-members-container {
  flex: 0 0 100%;
}
}
</style>
